// extracted by mini-css-extract-plugin
export var marginNegative = "_6j-5 _6j-3 _6j-1";
export var marginPositive = "_6j-4 _6j-3 _6j-1";
export var modalContent = "_6j-6";
export var samplesTable = "_6j-8";
export var samplesTableContainer = "_6j-7";
export var statBox = "_6j-a";
export var tableCell = "_6j-1";
export var tableCellCenter = "_6j-2 _6j-1";
export var tableCellRight = "_6j-3 _6j-1";
export var tableHeader = "_6j-0";
export var trackingNumber = "_6j-9";